module.exports = __webpack_public_path__ + "static/media/twitter.0967f7e9.svg";